import { render, staticRenderFns } from "./Pictures.vue?vue&type=template&id=4154a8e2&scoped=true&"
import script from "./Pictures.vue?vue&type=script&lang=js&"
export * from "./Pictures.vue?vue&type=script&lang=js&"
import style0 from "./Pictures.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154a8e2",
  null
  
)

export default component.exports